import { render, staticRenderFns } from "./ModalReminder.vue?vue&type=template&id=2ab297a5&scoped=true&"
import script from "./ModalReminder.vue?vue&type=script&lang=js&"
export * from "./ModalReminder.vue?vue&type=script&lang=js&"
import style0 from "./ModalReminder.vue?vue&type=style&index=0&id=2ab297a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab297a5",
  null
  
)

export default component.exports